import { QBus } from '@otto-ec/global-resources/event-q-bus'
import { Cmp } from '@otto-ec/eprivacy-cmp'
import { LoggingService } from '../utils/logging-service'
import { AppsAdapter } from '../adapter/apps.adapter'
import { attachMutationSafeClickHandler } from '../adapter/attach-mutation-safe-event-handler'

export class PrivacyPage {
  static readonly REJECT_ALL_CLASS = 'eprivacy_privacyPage_js_rejectAll'
  static readonly REJECT_GV_CLASS = 'eprivacy_privacyPage_js_rejectGV'
  static readonly OPEN_PREFERENCE_CENTER_CLASS =
    'eprivacy_privacyPage_js_open_preference_center'

  constructor(
    private readonly doc: Document,
    private readonly cmp: Cmp,
    private readonly eventBus: QBus,
    private readonly apps: AppsAdapter,
    private readonly logger: LoggingService
  ) {
    this.registerCbOptOutClick()
    this.registerCbGVOptOutClick()
    this.registerPreferenceCenterListener()
  }

  /**
 *
 */
  public handleAppDseSuccess() {
    this.emitGenericSettingsSavedSnackbarEvent()
  }

  /**
 *
 *
 *
 */
  public handleAppDseError(errormessage?: string) {
    this.logger.logError(
      new Error(
        'Error processing consent change in app: Errormessage: ' + errormessage
      )
    )
    this.emitGenericErrorSnackbarEvent()
  }

  private registerCbOptOutClick(): void {
    const clickEventHandler = () => this.rejectAllConsents()
    const className = PrivacyPage.REJECT_ALL_CLASS
    attachMutationSafeClickHandler(className, clickEventHandler, this.doc)
  }

  private registerCbGVOptOutClick(): void {
    const clickEventHandler = async (event: Event) => {
      const element = event.currentTarget as Element
      const gvid = element?.getAttribute('data-gvid')
      if (gvid != null) {
        await this.rejectGVConsent(gvid)
      }
    }

    attachMutationSafeClickHandler(
      PrivacyPage.REJECT_GV_CLASS,
      clickEventHandler,
      this.doc
    )
  }

  private async rejectAllConsents(): Promise<void> {
    this.cmp.rejectAll()
    if (this.apps.runningInApp()) {
      return
    }
    this.emitGenericSettingsSavedSnackbarEvent()
  }

  private async rejectGVConsent(generalVendorId: string): Promise<void> {
    this.cmp.rejectGeneralVendorConsent(generalVendorId)
    if (this.apps.runningInApp()) {
      return
    }
    this.emitGenericSettingsSavedSnackbarEvent()
  }

  private registerPreferenceCenterListener(): void {
    const listener = async () => {
      this.cmp.togglePreferenceCenter()
    }

    attachMutationSafeClickHandler(
      PrivacyPage.OPEN_PREFERENCE_CENTER_CLASS,
      listener,
      this.doc
    )
  }

  private emitGenericSettingsSavedSnackbarEvent() {
    this.emitSnackbarEvent(
      'Ihre Einwilligung wurde erfolgreich widerrufen.',
      '.gridAndInfoContainer'
    )
  }

  private emitGenericErrorSnackbarEvent() {
    this.emitSnackbarEvent(
      'Es ist ein Fehler aufgetreten, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
      '.gridAndInfoContainer'
    )
  }

  private emitSnackbarEvent(text: string, hostContainerSelector: string) {
    this.eventBus.emit('assets.snackbar.trigger', {
      text: text,
      hostContainerSelector: hostContainerSelector,
    })
  }
}
